import { ProfileFontSet } from "@authory-packages/core";
import { FakeProfileFontSetHeading, FakeProfileFontSetParagraph, FakeProfileSetSelectWrapper } from "./FakeProfileSetSelect.styles";
import { getFontSetLabels, getFontSetNames } from "../../utils/getFontSetLabels";
import { V3IconChevronDown } from "../Icons";

interface FakeProfileSetSelectProps {
    profileFontset: ProfileFontSet;
    isOption?: boolean;
}

export const FakeProfileSetSelect = ({ profileFontset, isOption = false }: FakeProfileSetSelectProps) => {
    const labels = getFontSetLabels(profileFontset);
    const fontSetNames = getFontSetNames(profileFontset);

    return (
        <FakeProfileSetSelectWrapper $isOption={isOption}>
            <div>
                <FakeProfileFontSetHeading $isOption={isOption} $fontFamily={fontSetNames.headingLabel}>
                    <strong>{labels.headingLabel}</strong>
                </FakeProfileFontSetHeading>
                <FakeProfileFontSetParagraph $isOption={isOption} $fontFamily={fontSetNames.paragraphLabel}>
                    {labels.paragraphLabel}
                </FakeProfileFontSetParagraph>
            </div>
            {!isOption && (
                <div>
                    <V3IconChevronDown />
                </div>
            )}
        </FakeProfileSetSelectWrapper>
    );
};
